import { Document, Page, View, pdf } from "@react-pdf/renderer";
import { toast } from "react-toastify";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
import { ANDROID, IOS } from "../components/commonItems/constants";
import { useContext } from "react";
import CurrentContext from "./CurrentContext";
import { scenesData } from "../pages/homePage";

export function FileDownload(url, name) {
  if (url) {
    const link = document.createElement("a");
    link.href = url;
    link.download = name ? name : url.split("?")[0].split("/").at(-1); // Extract name from url if name not passed
    link.click();
    link.remove();
  }
}

const MyPdfDocument = (pdfBody) => (
  <Document>
    <Page size="A4">
      <View>{pdfBody}</View>
    </Page>
  </Document>
);

export const getPdfForScene = async (pdfBody) => {
  const pdfBlob = await pdf(MyPdfDocument(pdfBody)).toBlob();
  return URL.createObjectURL(pdfBlob);
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function copyToClipBoard(value) {
  window.navigator.clipboard.writeText(value);
}

export const SuccessToastMessage = (message) => {
  toast.success(message, {});
};

export const ToastMessage = (message) => {
  toast.success(message, {});
};

export const ErrorToastMessage = (message) => {
  toast.error(message, {});
};

export const WarningToastMessage = (message) => {
  toast.warning(message, {});
};

export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return ANDROID;
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return IOS;
  }

  return null;
}




// region upload glb for AR
export async function handleExportGLTF({ currentScene, scene, fileName, setLoading }) {
  console.log("dekho : scene",scene)
  console.log("dekho : model",currentScene)
  setLoading?.(true);
  const gltfExporter = new GLTFExporter();
  const gltf = await new Promise((resolve) => {
    gltfExporter.parse(
      scene,
      (result) => {
        console.log("Parsed GLTF result:", result);
        resolve(result);
      }
    );
  });
  
  const blob = new Blob([JSON.stringify(gltf)], { type: "model/gltf" });

  const fileFormData = new FormData();
  fileFormData.append("file_url_key", `${fileName}.glb`);

  try {
    const createFileSpaceResponse = await fetch(
      "https://prod.imagine.io/users/api/v3/public/dynamic-ar-data/",
      {
        method: "POST",
        body: fileFormData,
      }
    ).then((res) => res.json());

    if (!createFileSpaceResponse) {
      return;
    }
    const { data } = createFileSpaceResponse || {};

    const unicodeApiUrl =
      "https://prod.imagine.io/users/api/v3/public/dynamic-ar-data/?unicode=" +
      data?.unicode;
    const presignedUrlData = data?.presigned_url_file;
    const presignedFields = presignedUrlData.fields;

    console.log({
      createFileSpaceResponse,
      unicodeApiUrl,
      presignedUrlData,
      presignedFields,
    });

    const fileUploadFormData = new FormData();
    for (const key in presignedFields) {
      fileUploadFormData.append(key, presignedFields[key]);
    }
    fileUploadFormData.append("file", blob, `${fileName}.glb`);

    // Here, we are uploading the file to S3 using the presigned URL
    const uploadedFileResponse = await fetch(presignedUrlData.url, {
      method: "POST",
      body: fileUploadFormData,
    });

    if (!uploadedFileResponse.ok) {
      throw new Error("Failed to upload file to S3");
    }

    console.log("File uploaded to S3");

    // Here, we are fetching the file from S3 using the unicode API
    const fileFetchedViaUnicode = await fetch(unicodeApiUrl).then((r) =>
      r.json()
    );

    console.log("DEBUG__finalData", {
      fileFetchedViaUnicode,
      uploadedFileResponse,
      unicodeApiUrl,
    });

    setLoading?.(false);

    return {
      file: fileFetchedViaUnicode?.data?.file,
      unicode: data?.unicode,
    };
  } catch (error) {
    console.error("Error:", error);
    setLoading?.(false);
  }
}
//endregion




export function setRotation(x, y, z) {
  return [(Math.PI / 180) * x, (Math.PI / 180) * y, (Math.PI / 180) * z];
}

export const handleToggleScreen = (
  elem = document.documentElement,
  setFullScreen = null
) => {
  if (document?.fullscreenEnabled) {
    if (!window?.document?.fullscreen || window.fullscreen) {
      if (elem?.requestFullscreen) {
        elem?.requestFullscreen?.();
      } else if (elem?.webkitRequestFullscreen) {
        /* Safari */
        elem?.webkitRequestFullscreen?.();
      } else if (elem?.msRequestFullscreen) {
        /* IE11 */
        elem?.msRequestFullscreen?.();
      }
      if (setFullScreen) setFullScreen(true);
    } else {
      if (document?.exitFullscreen) {
        document?.exitFullscreen?.();
      } else if (document?.webkitExitFullscreen) {
        /* Safari */
        document?.webkitExitFullscreen?.();
      } else if (document?.msExitFullscreen) {
        /* IE11 */
        document?.msExitFullscreen?.();
      }
      if (setFullScreen) setFullScreen(false);
    }
  } else {
    ErrorToastMessage("Fullscreen is not supported in this browser.");
    console.error("Fullscreen API is not supported in this browser.");
  }
};

export const getCurrentProductThumbnail = () => {
  const params = new URLSearchParams(window.location.search);
  const modelId = params.get("modelId");
  if (modelId) {
    return scenesData?.find((a) => a.id === +modelId)?.imgsrc || "";
  }

  return (
    scenesData?.find((a) => a.link === window.location.pathname)?.imgsrc ||
    "https://www.libertysafe.com/cdn/shop/files/Liberty_Safe_Logo_db44c619-7b99-4c42-8692-20f8c3c95e5a_x90@2x.png"
  );
};

export const isAndroid = () => navigator.userAgent.match(/Android/i);